import errorTransformer from '../shared/transformers/errorTransformer';
import FeatureFlags from './resources';

export default {
  // Returns the `featureFlags` object, e.g. { showAds, isNoInternetCondition }
  getConfig() {
    return FeatureFlags.getConfig()
      .then(({ body }) => body.featureFlags || {})
      .catch(errorTransformer);
  },
};
